import { AnswerType } from "types/rating.types"

export const initialTipStandardState = {
  q4: { order: 4, type: AnswerType.CHOICE, note: undefined },
}

export const initialTipColissimoState = {
  q1: { order: 1, type: AnswerType.CHOICE, note: undefined },
}
